import { Routes } from '@angular/router';
import { pendingInvoicesGuard } from './shared/pending-payments/guards/pending-invoices.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'cotizador',
    pathMatch: 'full',
  },
  {
    path: 'cotizador',
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    loadChildren: () =>
      import('./features/quoter/quoter.routes').then((m) => m.QUOTER_ROUTES),
  },
  {
    path: 'error',
    data: { title: 'Error', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path:'consultable-riesgos',
    data: { title: 'Consultable riesgos', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/consultable-risks/consultable-risks.page').then((m) => m.ConsultableRisksPage),
  },
  {
    path:'ciudad-inaccesible',
    data: { title: 'Ciudad inaccesible', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/inaccesible-city/inaccesible-city.page').then((m) => m.InaccesibleCityPage),
  },
  {
    path:'cumulo',
    data: { title: 'Cumulo', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/accumulation-page/accumulation-page.page').then((m) => m.AccumulationPage),
  },
  {
    path: 'pagos-pendientes',
    canActivate: [pendingInvoicesGuard],
    loadComponent: () =>
      import('./shared/pending-payments/pages/pending-invoices-page/pending-invoices-page.component').then(
        (m) => m.PendingInvoicesPageComponent,
      ),
  },
  {
    path: 'error-404',
    data: { title: 'Error 404', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/error-404/error-404.page').then((m) => m.Error404Page),
  },
  {
    path: 'error-500',
    data: { title: 'Error 500', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/error-500/error-500.page').then((m) => m.Error500Page),
  },
  {
    path: 'carnet-asegurado',
    data: { title: 'Carnet Asegurado', hideStepper: true },
    loadComponent: () =>
      import('./pages/pdf-viewer/pdf-viewer.page').then((m) => m.PdfViewerPage),
  },
  {
    path: 'verificar-informacion',
    data: { title: 'Verificar información registraduría', hideStepper: true },
    loadComponent: () =>
      import('./pages/terminal-flows/registry-info-verification/registry-info-verification.page').then((m) => m.RegistryInfoVerificationPage),
  },
  {
    path: '**',
    redirectTo: 'error-404',
  },

];
